// extracted by mini-css-extract-plugin
export default {"recipeCard":"RecipeItem_recipeCard__PrZ2l","recipeItemHeader":"RecipeItem_recipeItemHeader__3wEf5","recipeItemImage":"RecipeItem_recipeItemImage__PPgTu"};